export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"color-scheme","content":"light only"},{"name":"apple-itunes-app","content":"app-id=881463973"},{"name":"description","content":"Официальный сайт сети «Магнит Косметик»"},{"name":"keywords","content":"Магнит Косметик онлайн, цены, акции и скидки, каталог товаров, купить, дёшево, магазин косметики, бытовая химия, товары для дома, средства для уборки, чистящие средства, средства гигиены"},{"name":"yandex-verification","content":"b39fe297eb40ec98"},{"property":"og:site_name","content":"Магнит Косметик"},{"property":"og:type","content":"website"},{"property":"og:description","content":"Косметика, бытовая химия и товары для дома по низким ценам"},{"name":"image","content":"/cosmetic-share-1200x630.webp"},{"property":"og:image","content":"/cosmetic-share-1200x630.webp"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:image","content":"/cosmetic-share-200x200.webp"},{"property":"og:image:width","content":"200"},{"property":"og:image:height","content":"200"},{"property":"og:url","content":"https://cosmetic.magnit.ru"},{"name":"twitter:image","content":"/cosmetic-share-1200x630.webp"},{"name":"twitter:card","content":"summary_large_image"}],"link":[{"rel":"apple-touch-ico","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/svg+xml","sizes":"any","href":"/favicon.svg"},{"rel":"icon","type":"image/x-icon","sizes":"16x16 32x32","href":"/favicon.ico"}],"style":[],"script":[{"hid":"yandex","children":"(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n           m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n           (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n           ym(92154139, \"init\", {\n                clickmap:true,\n                trackLinks:true,\n                accurateTrackBounce:true,\n                webvisor:true,\n           });","type":"text/javascript"}],"noscript":[],"htmlAttrs":{"lang":"ru"},"title":"Магнит Косметик"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true